import {action, observable} from "mobx";

import type {IAdBannerSettings} from 'OK/ads/banner/hook/IBannerJson';

import {IRbAdBannerEmergedFooterAttrs} from './RbAdBannerEmergedFooterAttrs';

export class RbAdBannerEmergedFooterStore {
    public readonly settings: IAdBannerSettings;

    @observable
    public show: boolean;

    constructor(attrs: IRbAdBannerEmergedFooterAttrs) {
        this.settings = attrs.settings;
        this.show = false;
    }

    initShow() {
        const show = !window.document.querySelector('.promo-banner');
        this.setShow(show);
        return show;
    }

    @action
    setShow(show: boolean) {
        this.show = show;
    }
}
